import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { Separator } from '@velasca/ui/separator'

export const TitleWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.brand};
`

export const ShoeDescriptionWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin: 4rem 0;
`

export const ModalSeparator = styled(Separator)`
  width: 6.9rem;
  margin: 3rem 0;
`

export const ShoeAdvices = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2rem;
  padding: 2.4rem 2.4rem 0;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 0.6rem;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding: 2rem 0.5rem;
  }
`

export const AdviceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 2.4rem;

  @media screen and (min-width: 768px) {
    align-items: flex-start;
    width: 50%;
    padding: 0 3.5rem;
    font-size: 1.5rem;
    line-height: 1.8rem;
  }
`

export const AdviceImage = styled(ResponsiveImage)`
  max-width: 9.6rem;
  height: auto;
  align-self: center;
  margin-bottom: 3.4rem;
`
